import './components/header/account-menu.js';
import './components/account/account.js';

// Import Vendors
import FarloUiLightbox from './vendors/farlo-ui-lightbox';
import FarloUiSelectBox from './vendors/farlo-ui-selectbox';
import FarloUiRevolverCarousel from './vendors/farlo-ui-revolver-carousel';
import FarloUiLazyLoad from './vendors/farlo-ui-lazyload.js';
import addLightboxToGallery from './vendors/farlo-ui-gallery-lightbox.js';

// Import Footer Components
import siteSearch from './components/footer/search.js';
import farloUiCrmSignup from './components/footer/farloUiCrmSignup.js';
import collapsibleContent from './components/footer/collapsibleContent.js';
import { elementInView } from './components/footer/elementInView.js';
import { faqs } from './components/footer/faqs.js';
import { navigation, navicon } from './components/footer/navigation.js';
import { smoothScrollToAnchor } from './components/footer/smoothScrollToAnchor.js';
import { embedOverlay } from './components/footer/embedOverlay.js';
import { mapLoader } from './components/footer/mapLoader.js';
import { showPage } from './components/footer/showPage.js';
import { venuePage } from './components/footer/venuePage.js';
import { hydrateTicketListing } from './components/footer/ticketListing.js';
import showFilters from './components/footer/filters.js';
import accessFilters from './components/footer/accessFilters.js';
import ticketBoothFilters from './components/footer/ticketBoothFilters.js';
import miniTicketCalendar from './components/footer/miniTicketCalendar.js';
import bigTicketCalendar from './components/footer/bigTicketCalendar.js';
import globalModal from './components/footer/globalModal.js';
import initNewsListing from './components/footer/newsListing.js';
import initOlivierAwardsYear from './components/footer/olivierAwards.js';
import initAccordions from './components/footer/accordion.js';
import initVenueDirections from './components/footer/venueDirections.js';
import newsletterInlineForm from './components/footer/newsletterInlineForm.js';
import initAccessNewsletter from './components/footer/newsletterAccessSignup.js';
import { equalHeightColumns } from './components/footer/equalHeightColumns.js';
import mountNewsletterSignup from './components/footer/newsletter';
import './components/footer/pageDescriptionToggle.js';
import todaysTicketsFilters from './components/footer/todaysTicketsFilters.js';
import { initShowCardTabs } from './components/footer/ticketBoothTabs.js';
import { hydrateCampaignShows } from './components/footer/hydrateCampaignShows.js';
import initCampaignFilters from './components/footer/campaignFilters';
import informationBanners from './components/footer/informationBanners.js';

((document, window, history) => {
	const pushState = history.pushState;

	history.pushState = function(state) {
		if (typeof history.onpushstate === 'function') {
			history.onpushstate({ state });
		}
		return pushState.apply(history, arguments);
	};

	document.addEventListener('DOMContentLoaded', () => {
		if (document.querySelector('.site-navigation__navicon')) {
			navicon();
		}

		if (document.querySelector('.site-header__navigation')) {
			navigation(document);
		}

		if (document.querySelector('.site-header__search')) {
			siteSearch();
		}

		if (document.querySelector('form[data-newsletter-simple]')) {
			farloUiCrmSignup();
		}

		if (document.querySelector('.is-style-lightbox-gallery')) {
			addLightboxToGallery();
		}

		if (document.querySelectorAll('.wp-block-embed')) {
			embedOverlay();
		}

		if (document.querySelector('.farlo-ui-map')) {
			mapLoader();
		}

		if (document.querySelector('[farlo-ui="calendar-mini"]')) {
			miniTicketCalendar();
		}

		if (document.querySelector('[farlo-ui="calendar-big"]')) {
			bigTicketCalendar();
		}

		document.querySelectorAll('a[href*="#"]').forEach((_sel) => {
			smoothScrollToAnchor(_sel);
		});

		if (document.querySelector('.site-faqs')) {
			faqs();
		}

		if (document.querySelector('.single-show')) {
			showPage();
		}

		if (document.querySelector('.single-venue')) {
			venuePage();
			initVenueDirections();
		}

		if (document.querySelector('.site-tickets-filters')) {
			showFilters();
		}

		if (document.querySelector('.shows-grid__items')) {
			hydrateTicketListing();
		}

		if (document.querySelector('[data-access-filterbar]')) {
			accessFilters();
		}

		if (document.querySelector('[data-ticketbooth-filterbar]')) {
			ticketBoothFilters();
		}

		if (document.querySelector('[data-todays-tickets-filterbar]')) {
			todaysTicketsFilters();
		}

		if (document.querySelector('[data-campaign-filterbar]')) {
			initCampaignFilters();
		}

		if (document.querySelector('.newsletter-inline__form')) {
			newsletterInlineForm();
		}

		if (document.querySelector('form[data-newsletter-access]')) {
			initAccessNewsletter();
		}

		if (document.querySelector('[data-campaign-hydrate]')) {
			hydrateCampaignShows();
		}

		if (document.querySelector('.farlo-ui-animated')) {
			document.querySelectorAll('.farlo-ui-animated').forEach((_sel) => {
				elementInView(_sel);
			});
		}

		if (document.querySelector('.site-columns-content')) {
			collapsibleContent();
		}

		if (document.querySelector('.equal-height-column')) {
			equalHeightColumns();
		}

		if (document.querySelector('[data-news-list]')) {
			initNewsListing();
		}

		if (document.querySelector('.site-olivier-awards__controls')) {
			initOlivierAwardsYear(document);
		}

		if (document.querySelector('.site-newsletter-signup')) {
			mountNewsletterSignup();
		}

		if (document.querySelector('.site-page')?.querySelector('iframe')) {
			document.querySelectorAll('iframe').forEach((_sel) => {
				if (_sel.parentNode && _sel.parentNode.nodeName === 'P') {
					_sel.parentNode.classList.add('iframe-container');
				}
			});
		}

		if (document.querySelector('.site-accordion')) {
			initAccordions(document);
		}

		if (document.querySelector('.ticket-booth-show-card')) {
			initShowCardTabs();
		}

		if (document.querySelector('select')) {
			document.querySelectorAll('select').forEach((_sel) => {
				new FarloUiSelectBox(_sel);
			});
		}

		if (document.querySelector('.farlo-ui-lightbox__toggle')) {
			document.querySelectorAll('.farlo-ui-lightbox__toggle').forEach((_sel) => {
				new FarloUiLightbox(_sel);
			});
		}

		if (document.querySelector('.farlo-ui-revolver-carousel')) {
			document.querySelectorAll('.farlo-ui-revolver-carousel').forEach((_sel) => {
				if (!_sel.dataset.carouselInitialised) {
					new FarloUiRevolverCarousel(_sel);
					_sel.dataset.carouselInitialised = 'true';
				}
			});
		}

		if (document.querySelector('.lazy')) {
			new FarloUiLazyLoad(document);
		}

		globalModal();
		informationBanners();
	});

	if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
		navigator.serviceWorker.getRegistrations().then(function(registrations) {
			for (const registration of registrations) {
				registration.unregister();
			}
		});
	}
})(document, window, history);
